import { useEffect, useState } from "react";
import { fetchCategories } from "@/lib/api";

export function useCategories() {
  const [meta, setMeta] = useState({});
  useEffect(() => {
    fetchCategories().then((list) => {
      const map = {};
      list.forEach((c) => (map[c.id] = c));
      setMeta(map);
    });
  }, []);
  return meta;
}
